// supabaseClient.js
import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://cfpekzuxhgkeonhgbwmi.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNmcGVrenV4aGdrZW9uaGdid21pIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjUyMDg4NTYsImV4cCI6MjA0MDc4NDg1Nn0.fkJVWGRbjeaECvxuDdggyQTtid4XVBgwYTiWLOSRKDU';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
